import React, { useEffect, useState, useContext } from 'react';
import ClaiborneImg from "../assets/images/anthony-ad.jpg";
import TransactionIpImg from "../assets/images/transaction-ip.jpeg";
import HumanVerticalImg from "../assets/images/Human-Vertical.jpg";
import ApplicationContext from './ApplicationContext';

const Links = () => {
	const data = useContext(ApplicationContext);

	const [linkData, setLinkData] = useState();
	useEffect(() => {
		if (data.linkData) {
			setLinkData(data.linkData);
		}
	}, [data.linkData]);

	return (
		<>
			{linkData && <h3>Special Report Links</h3>}
			<div>
				{linkData && linkData?.map((e,i,arr) => {
					const last = linkData.length-1;
					if ((i % 2) !== 0) {
						// console.log('DEBUG', arr[i-1].URL, arr[i-1].TITLE);
						// console.log('DEBUG', e.URL, e.TITLE);
						return (
							<div key={i} className="link-row">
								<div className="link-container">
									<a href={arr[i-1].URL} target="_blank" rel="noreferrer">{arr[i-1].TITLE}</a>
								</div>
								<div className="link-container">
									<a href={e.URL} target="_blank" rel="noreferrer">{e.TITLE}</a>
								</div>
							</div>
						);
					}
					// if the current entry is the odd index and the last one then display it and an 
					// empty column on the right.
					else if (i === last && (i % 2) !== 1) {
						return (
							<div key={i} className="link-row">
								<div className="link-container">
									<a href={e.URL} target="_blank" rel="noreferrer">{e.TITLE}</a>
								</div>
								<div className="link-container">
								</div>
							</div>
						);
					}
					else {
						return (<></>);
					}
				})}

				{/* <div className="link-row">
					<div className="link-container hide">
						<iframe className="link-frameborder" height="195" src="https://embed.podcasts.apple.com/us/podcast/the-immigrant-entrepreneurs/id1716120289?i=1000641173508" />
					</div>
				</div> */}

				<div className="ad-banner-container hide">
					<div className="ad-banner">
						<a href="https://claiborne-ip.com/" target="__blank">
							<img src={ClaiborneImg} alt="Claiborne Ad" />
						</a>
					</div>
				</div>

				<div className="ad-banner-container hide">
					<div className="ad-banner">
						<a href="https://transactionsip.com/" target="__blank">
							<img src={TransactionIpImg} alt="Transaction IP Ad" />
						</a>
					</div>
				</div>

				<div className="ad-banner-container hide">
					<div className="ad-banner">
						<a href="https://humanvertical.mozello.com/" target="__blank">
							<img src={HumanVerticalImg} alt="Human Vertical" />
						</a>
					</div>
				</div>
			</div>
		</>
	);
}

export default Links;
